import { StatusInfo } from "./core/StatusInfo";
import { message } from "antd";
import _, { debounce } from "lodash";
import { action, makeAutoObservable, runInAction } from "mobx";
import moment from "moment";
import { getFilesWithThumbUrls } from "../api/helpers";
import { Search, SearchRequest } from "../api/Types";
import ApiBuildings from "../modules/OrganisationProfile/api/Buildings";
import { ExpandableKeys, PerPageSettings } from "./core";
import { WithBooleanFlag } from "./core/WithBooleanFlag";
import { contractTypes } from "../modules/OrganisationProfile/components/ListOfBuildings/constants";
import Constants from "../constants/Common";

export interface ICurrentBuilding {
  id?: number;
  name?: string;
  address?: string;
  funcTypeGroupId?: number;
  isLoading?: boolean;
  lat?: number;
  lon?: number;
  dtStartExpl?: Date;
}
export class BuildingsStore {
  //all buildings
  allBuildings = [];

  //GET REQ
  allGetBuildings = [];
  currentBuilding = {} as ICurrentBuilding;
  isLoadingCurrentB = new WithBooleanFlag();
  currentStatus = "";

  //buildings list of buildings tab
  buildingsOrg = [];
  buildingsListTab = [];
  paginatorBuildingsTab = new PerPageSettings();
  buildingsTabStatus = new WithBooleanFlag();
  buildingsTabRowKeys = new ExpandableKeys();
  searchTextBuildingsTab = "";
  searchBuildingsTab: Search = {};

  //passport
  buildingsPassport = [];
  paginatorBuildingsPassport = new PerPageSettings();
  buildingsPassportStatus = new WithBooleanFlag();
  buildingsPassportRowKeys = new ExpandableKeys();
  searchTextBuildingsPassport = "";
  searchBuildingsPassport: Search = {};

  //lightings
  buildingsLights = [];
  paginatorBuildingsLights = new PerPageSettings();
  buildingsLightsStatus = new WithBooleanFlag();
  buildingsLightsRowKeys = new ExpandableKeys();
  searchTextBuildingsLights = "";
  searchBuildingsLights: Search = {};

  //water
  buildingsWater = [];
  paginatorBuildingsWater = new PerPageSettings();
  buildingsWaterStatus = new WithBooleanFlag();
  buildingsWaterRowKeys = new ExpandableKeys();
  searchTextBuildingsWater = "";
  searchBuildingsWater: Search = {};
  datesToCheck = [
    "heatingContract.signDt",
    "heatingContract.startDt",
    "electricityContract.signDt",
    "electricityContract.startDt",
    "gvsContract.signDt",
    "gvsContract.startDt",
    "gasContract.signDt",
    "gasContract.startDt",
    "coldWaterContract.signDt",
    "coldWaterContract.startDt",
  ];
  messageStatus = new StatusInfo();
  buildingsUpdateStatus = new WithBooleanFlag(false);

  constructor() {
    makeAutoObservable(
      this,
      { setAllBuildings: action },
      { autoBind: true, deep: true },
    );
  }

  //buildings list tab

  debouncedSearchBuildingsTabs = debounce(() => {
    runInAction(() => {
      this.searchBuildingsTab = {
        text: this.searchTextBuildingsTab.trim().toLowerCase(),
      };
    });
  }, 300);

  handleChangeSearchBuildingsTab = (val) => {
    runInAction(() => {
      this.searchTextBuildingsTab = val;
      this.debouncedSearchBuildingsTabs();
    });
  };

  handleClearSearchBuildingsTab = () => {
    runInAction(() => {
      this.searchTextBuildingsTab = "";
      this.debouncedSearchBuildingsTabs();
    });
  };

  getBuildingsTab = async (id) => {
    this.buildingsTabStatus.setTrue();
    try {
      const model: SearchRequest = {
        page: this.paginatorBuildingsTab.page,
        count: this.paginatorBuildingsTab.perPage,
        search: this.searchBuildingsTab,
      };
      const { data } = await ApiBuildings.getBuildings(id, model);

      data.items.forEach((building) => {
        const arr = ["dtStartExpl", ...this.datesToCheck];

        for (const fieldName of arr) {
          const date = _.get(building, fieldName);
          if (date) {
            _.set(building, fieldName, moment(date));
          }
        }

        building.stockDeclarations.forEach((file) => {
          file.loading = true;
        });

        for (const contractName of contractTypes) {
          if (building[`${contractName}Contract`]?.docs?.length) {
            building[`${contractName}Files`] = building[
              `${contractName}Contract`
            ].docs.map((doc) => {
              return { loading: true };
            });
          }
          if (building[`${contractName}Contract`]?.agreements?.length > 0) {
            for (
              let i = 0;
              i < building[`${contractName}Contract`].agreements.length;
              i++
            ) {
              building[`${contractName}Contract`].agreements[i].agreementFiles =
                building[`${contractName}Contract`].agreements[
                  i
                ].agreementFiles.map((f) => ({ ...f, loading: true }));
            }
          }
        }
      });
      runInAction(() => {
        this.buildingsListTab = data.items;
        this.paginatorBuildingsTab.updateMeta(data);
      });
      this.getFilesForBuildingsTab(data.items);
    } catch (error) {
      console.log(error);
    } finally {
      this.buildingsTabStatus.setFalse();
    }
  };

  getFilesForBuildingsTab = async (buildings) => {
    try {
      for (const building of buildings) {
        if (building.stockDeclarations.length) {
          building.stockDeclarations = await getFilesWithThumbUrls(
            building.stockDeclarations,
          );
        }
        for (const contractName of contractTypes) {
          if (building[`${contractName}Contract`]?.docs.length) {
            building[`${contractName}Files`] = await getFilesWithThumbUrls(
              building[`${contractName}Contract`].docs.map((i) => i.file),
            );
          }
          if (building[`${contractName}Contract`]?.agreements.length > 0) {
            for (
              let i = 0;
              i < building[`${contractName}Contract`].agreements.length;
              i++
            ) {
              building[`${contractName}Contract`].agreements[i].agreementFiles =
                await getFilesWithThumbUrls(
                  building[`${contractName}Contract`].agreements[
                    i
                  ].agreementFiles.map((f) => f.file),
                );
            }
          }
        }
      }
      runInAction(() => {
        this.buildingsListTab = buildings;
      });
    } catch (e) {
      console.log(e);
    }
  };

  //passport

  debouncedSearchBuildingsPassport = debounce(() => {
    runInAction(() => {
      this.searchBuildingsPassport = {
        text: this.searchTextBuildingsPassport.trim().toLowerCase(),
      };
    });
  }, 300);

  handleChangeSearchBuildingsPassport = (val) => {
    runInAction(() => {
      this.searchTextBuildingsPassport = val;
      this.debouncedSearchBuildingsPassport();
    });
  };

  handleClearSearchBuildingsPassport = () => {
    runInAction(() => {
      this.searchTextBuildingsPassport = "";
      this.debouncedSearchBuildingsPassport();
    });
  };

  getBuildingsPassport = async (id) => {
    this.buildingsPassportStatus.setTrue();
    try {
      const model: SearchRequest = {
        page: this.paginatorBuildingsPassport.page,
        count: this.paginatorBuildingsPassport.perPage,
        search: this.searchBuildingsPassport,
      };
      const { data } = await ApiBuildings.getBuildings(id, model);

      runInAction(() => {
        this.buildingsPassport = data.items;
        this.paginatorBuildingsPassport.updateMeta(data);
      });
    } catch (error) {
      runInAction(() => {
        console.log(error);
      });
    } finally {
      this.buildingsPassportStatus.setFalse();
    }
  };

  //lights

  debouncedSearchBuildingsLights = debounce(() => {
    runInAction(() => {
      this.searchBuildingsLights = {
        text: this.searchTextBuildingsLights.trim().toLowerCase(),
      };
    });
  }, 300);

  handleChangeSearchBuildingsLights = (val) => {
    runInAction(() => {
      this.searchTextBuildingsLights = val;
      this.debouncedSearchBuildingsLights();
    });
  };

  handleClearSearchBuildingsLights = () => {
    runInAction(() => {
      this.searchTextBuildingsLights = "";
      this.debouncedSearchBuildingsLights();
    });
  };

  getBuildingsLights = async (id) => {
    this.buildingsLightsStatus.setTrue();
    try {
      const model: SearchRequest = {
        page: this.paginatorBuildingsLights.page,
        count: this.paginatorBuildingsLights.perPage,
        search: this.searchBuildingsLights,
      };
      const { data } = await ApiBuildings.getBuildings(id, model);
      runInAction(() => {
        this.buildingsLights = data.items;
        this.paginatorBuildingsLights.updateMeta(data);
      });
    } catch (error) {
      runInAction(() => {
        console.log(error);
      });
    } finally {
      this.buildingsLightsStatus.setFalse();
    }
  };

  //water

  debouncedSearchBuildingsWater = debounce(() => {
    runInAction(() => {
      this.searchBuildingsWater = {
        text: this.searchTextBuildingsWater.trim().toLowerCase(),
      };
    });
  }, 300);

  handleChangeSearchBuildingsWater = (val) => {
    runInAction(() => {
      this.searchTextBuildingsWater = val;
      this.debouncedSearchBuildingsWater();
    });
  };

  handleClearSearchBuildingsWater = () => {
    runInAction(() => {
      this.searchTextBuildingsWater = "";
      this.debouncedSearchBuildingsWater();
    });
  };

  getBuildingsWater = async (id) => {
    this.buildingsWaterStatus.setTrue();
    try {
      const model: SearchRequest = {
        page: this.paginatorBuildingsWater.page,
        count: this.paginatorBuildingsWater.perPage,
        search: this.searchBuildingsWater,
      };
      const { data } = await ApiBuildings.getBuildings(id, model);
      runInAction(() => {
        this.buildingsWater = data.items;
        this.paginatorBuildingsWater.updateMeta(data);
      });
    } catch (error) {
      runInAction(() => {
        console.log(error);
      });
    } finally {
      this.buildingsWaterStatus.setFalse();
    }
  };

  getAllGetBuildingsByOrg = async (id) => {
    try {
      if (!id) {
        this.allGetBuildings = [];
        this.allBuildings = [];
        return;
      }

      const { data } = await ApiBuildings.getAllGetBuildings(id);
      runInAction(() => {
        this.allGetBuildings = data;
        this.allBuildings = data;
      });
    } catch (error) {
      console.log(error);
    }
  };
  setAllBuildings = (data = []) => {
    this.allBuildings = data;
  };

  getCurrentBuildingByOrg = async ({ orgId, buildingId }) => {
    this.currentStatus = "pending";
    this.isLoadingCurrentB.setTrue();
    try {
      this.currentStatus = "pending";
      const { data } = await ApiBuildings.getCurrentBuilding({
        orgId,
        buildingId,
      });

      runInAction(() => {
        this.currentBuilding = { ...data };
        this.currentStatus = "done";
      });
    } catch (error) {
      runInAction(() => {
        console.log(error);
        this.currentStatus = "error";
      });
    } finally {
      this.isLoadingCurrentB.setFalse();
    }
  };

  validateAgreements = (agreements): boolean => {
    let valid = true;
    agreements.forEach((item) => {
      if (!item.created || !item.startDate) {
        valid = false;
      }
    });
    if (!valid) {
      message.error(
        'Заполните поля "Дата доп. соглашения" и "Дата начала действия доп. соглашения"',
      );
    }
    return valid;
  };

  updateBuilding = async (id, body) => {
    this.buildingsUpdateStatus.setTrue();
    try {
      // if (body.electricityContract?.agreements?.length) {
      //   if (!this.validateAgreements(body.electricityContract?.agreements))
      //     return;
      // }
      const res = await ApiBuildings.saveBuilding(id, body);
      runInAction(() => {
        if (res.status === 200) {
          body?.id
            ? this.buildingsTabRowKeys.remove(body?.id)
            : this.buildingsTabRowKeys.setKeys([]);
          this.messageStatus.setStatus(Constants.requestStatuses.updated);
          this.getBuildingsTab(id);
        }
      });
    } catch (error) {
      console.log(error);
      runInAction(() => {
        this.messageStatus.setDetails(error);
        this.messageStatus.setStatus(Constants.requestStatuses.error);
      });
    } finally {
      this.buildingsUpdateStatus.setFalse();
    }
  };

  updateBuildings = (data) => {
    runInAction(() => {
      this.buildingsOrg = this.buildingsOrg.map((elem) =>
        elem.id === data.id ? data : elem,
      );
      this.buildingsPassport = this.buildingsPassport.map((elem) =>
        elem.id === data.id ? data : elem,
      );
    });
  };
}

export const buildingsStore = new BuildingsStore();
